import { createLoadingSpinner, LoadingSpinner } from '@vfde-brix/ws10/loading-spinner';
import { HtmlId } from '../enum';
import { mountComponent } from '../util/mount';

export const mountLoadingSpinner = (id: HtmlId) =>
    mountComponent(id, createLoadingSpinner, {
        optNested: true,
        optSize: 'medium',
        business: {},
    });

export const updateLoadingSpinner = (comp: LoadingSpinner | null, show: boolean) => {
    if (!comp) {
        return;
    }

    comp.toggleContainer(!show);
    comp.toggle(show);
};
